<template>

    <div>
        <v-row no-gutters>
            <base-header>
                <div slot="page-header">Market Trade</div>
            </base-header>
        </v-row>
     
        <v-row no-gutters>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">


                        <v-row align="start">
                            <v-avatar :color="checking ? 'red lighten-2' : 'green'" class="mr-12" size="64"
                                @click="takePulse">
                                <img src="../../assets/images/coin/btc.png" alt="John">
                            </v-avatar>
                            <div class="mt-2">
                                <span class="text-h3 font-weight-black" v-text="avg || '—'"></span>
                                <strong v-if="avg">BTC</strong>
                            </div>
                        </v-row>


                    </div>
                    <div slot="card-body">
                        <v-sheet color="transparent">
                            <v-sparkline :key="String(avg)" :smooth="16" :gradient="['#ff0000', '#ff7878']"
                                :line-width="3" :value="heartbeats" auto-draw stroke-linecap="round"></v-sparkline>
                        </v-sheet>
                    </div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">


                        <v-row align="start">
                            <v-avatar :color="checking ? 'red lighten-2' : 'green'" class="mr-12" size="64"
                                @click="takePulse">
                                <img src="../../assets/images/coin/mana.png" alt="John">
                            </v-avatar>
                            <div class="mt-2">
                                <span class="text-h3 font-weight-black" v-text="avg || '—'"></span>
                                <strong v-if="avg">MANA</strong>
                            </div>
                        </v-row>


                    </div>
                    <div slot="card-body">
                        <v-sheet color="transparent">
                            <v-sparkline :key="String(avg)" :smooth="16" :gradient="['#ff0000', '#ff7878']"
                                :line-width="3" :value="heartbeats" auto-draw stroke-linecap="round"></v-sparkline>
                        </v-sheet>
                    </div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">


                        <v-row align="start">
                            <v-avatar :color="checking ? 'red lighten-2' : 'green'" class="mr-12" size="64"
                                @click="takePulse">
                                <img src="../../assets/images/coin/link.png" alt="John">
                            </v-avatar>
                            <div class="mt-2">
                                <span class="text-h3 font-weight-black" v-text="avg || '—'"></span>
                                <strong v-if="avg">LINK</strong>
                            </div>
                        </v-row>


                    </div>
                    <div slot="card-body">
                        <v-sheet color="transparent">
                            <v-sparkline :key="String(avg)" :smooth="16" :gradient="['#ff0000', '#ff7878']"
                                :line-width="3" :value="heartbeats" auto-draw stroke-linecap="round"></v-sparkline>
                        </v-sheet>
                    </div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <base-card color="primary">
                    <div slot="card-header">


                        <v-row align="start">
                            <v-avatar :color="checking ? 'red lighten-2' : 'green'" class="mr-12" size="64"
                                @click="takePulse">
                                <img src="../../assets/images/coin/bnb.png" alt="John">
                            </v-avatar>
                            <div class="mt-2">
                                <span class="text-h3 font-weight-black" v-text="avg || '—'"></span>
                                <strong v-if="avg">BNB</strong>
                            </div>
                        </v-row>


                    </div>
                    <div slot="card-body">
                        <v-sheet color="transparent">
                            <v-sparkline :key="String(avg)" :smooth="16" :gradient="['#ff0000', '#ff7878']"
                                :line-width="3" :value="heartbeats" auto-draw stroke-linecap="round"></v-sparkline>
                        </v-sheet>
                    </div>
                </base-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" lg="6" xl="6">
                <base-card color="primary">
                    <div slot="card-header">

                    </div>
                    <div slot="card-body">
                        <chart-candle></chart-candle>
                    </div>
                </base-card>
            </v-col>
            <v-col cols="12" lg="6" xl="6">

                <card-search></card-search>

            </v-col>
        </v-row>
            <v-row no-gutters>
            <v-col cols="12" lg="12" xl="12">

                <card-market></card-market>

            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" lg="12" xl="12">

                <card-tab></card-tab>

            </v-col>
        </v-row>


    </div>
</template>

<script>
    import BaseCard from "../../components/Base/BaseCard.vue";
    import BaseHeader from "../../components/Base/BaseHeader.vue";
    import CardMarket from '../../components/Cards/CardMarket'
    import CardTab from '../../components/Cards/CardTab'
    import ChartCandle from '../../components/Charts/ChartCandle'
      import CardSearch from '../../components/Cards/CardSearch.vue'
       
    export default {
        components: {
            BaseCard,
            CardMarket,
            CardTab,
            ChartCandle,
            BaseHeader,CardSearch


        },
        data: () => ({
            checking: false,
            heartbeats: [],
        }),

        computed: {
            avg() {
                const sum = this.heartbeats.reduce((acc, cur) => acc + cur, 0)
                const length = this.heartbeats.length

                if (!sum && !length) return 0

                return Math.ceil(sum / length)
            },
        },

        created() {
            this.takePulse(false)
        },

        methods: {
            heartbeat() {
                return Math.ceil(Math.random() * (120 - 80) + 80)
            },
            async takePulse(inhale = true) {
                this.checking = true

                inhale && await exhale(1000)

                this.heartbeats = Array.from({
                    length: 20
                }, this.heartbeat)

                this.checking = false
            },
        },
    }
</script>